import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1590e23a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "navbar navbar-custom custom-header mb-0"
}
const _hoisted_2 = { class: "container-fluid navbar-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2 col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn",
    type: "button",
    "data-bs-toggle": "offcanvas",
    "data-bs-target": "#appMenu",
    "aria-controls": "appMenu"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list fa-2x" })
  ])
], -1))
const _hoisted_4 = { class: "col text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-2 col-xl-3 text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 2C17.523 2 22 6.477 22 12C22.0035 14.3079 21.2053 16.5453 19.742 18.33L19.762 18.352L19.63 18.464C18.6921 19.5731 17.5235 20.4642 16.2056 21.0749C14.8878 21.6856 13.4525 22.0014 12 22C9.05001 22 6.40001 20.723 4.57001 18.693L4.37001 18.463L4.23801 18.353L4.25801 18.329C2.79491 16.5446 1.9968 14.3075 2.00001 12C2.00001 6.477 6.47701 2 12 2ZM12 17C10.14 17 8.45901 17.592 7.20701 18.406C8.5896 19.4429 10.2718 20.0024 12 20C13.7282 20.0024 15.4104 19.4429 16.793 18.406C15.3623 17.4894 13.6991 17.0015 12 17ZM12 4C10.4945 3.99996 9.0196 4.42471 7.74473 5.22545C6.46987 6.02619 5.44682 7.1704 4.79317 8.52657C4.13952 9.88274 3.88181 11.3958 4.04966 12.8919C4.21751 14.388 4.8041 15.8064 5.74201 16.984C7.36301 15.821 9.57501 15 12 15C14.425 15 16.637 15.821 18.258 16.984C19.1959 15.8064 19.7825 14.388 19.9504 12.8919C20.1182 11.3958 19.8605 9.88274 19.2069 8.52657C18.5532 7.1704 17.5302 6.02619 16.2553 5.22545C14.9804 4.42471 13.5055 3.99996 12 4ZM12 6C13.0609 6 14.0783 6.42143 14.8284 7.17157C15.5786 7.92172 16 8.93913 16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92173 13.5786 9.17158 12.8284C8.42144 12.0783 8.00001 11.0609 8.00001 10C8.00001 8.93913 8.42144 7.92172 9.17158 7.17157C9.92173 6.42143 10.9391 6 12 6ZM12 8C11.4696 8 10.9609 8.21071 10.5858 8.58579C10.2107 8.96086 10 9.46957 10 10C10 10.5304 10.2107 11.0391 10.5858 11.4142C10.9609 11.7893 11.4696 12 12 12C12.5304 12 13.0392 11.7893 13.4142 11.4142C13.7893 11.0391 14 10.5304 14 10C14 9.46957 13.7893 8.96086 13.4142 8.58579C13.0392 8.21071 12.5304 8 12 8Z",
    fill: "white"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4 fw-normal d-none d-xl-inline" }, " Iniciar sesión o registrate ", -1))
const _hoisted_9 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 2C17.523 2 22 6.477 22 12C22.0035 14.3079 21.2053 16.5453 19.742 18.33L19.762 18.352L19.63 18.464C18.6921 19.5731 17.5235 20.4642 16.2056 21.0749C14.8878 21.6856 13.4525 22.0014 12 22C9.05001 22 6.40001 20.723 4.57001 18.693L4.37001 18.463L4.23801 18.353L4.25801 18.329C2.79491 16.5446 1.9968 14.3075 2.00001 12C2.00001 6.477 6.47701 2 12 2ZM12 17C10.14 17 8.45901 17.592 7.20701 18.406C8.5896 19.4429 10.2718 20.0024 12 20C13.7282 20.0024 15.4104 19.4429 16.793 18.406C15.3623 17.4894 13.6991 17.0015 12 17ZM12 4C10.4945 3.99996 9.0196 4.42471 7.74473 5.22545C6.46987 6.02619 5.44682 7.1704 4.79317 8.52657C4.13952 9.88274 3.88181 11.3958 4.04966 12.8919C4.21751 14.388 4.8041 15.8064 5.74201 16.984C7.36301 15.821 9.57501 15 12 15C14.425 15 16.637 15.821 18.258 16.984C19.1959 15.8064 19.7825 14.388 19.9504 12.8919C20.1182 11.3958 19.8605 9.88274 19.2069 8.52657C18.5532 7.1704 17.5302 6.02619 16.2553 5.22545C14.9804 4.42471 13.5055 3.99996 12 4ZM12 6C13.0609 6 14.0783 6.42143 14.8284 7.17157C15.5786 7.92172 16 8.93913 16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92173 13.5786 9.17158 12.8284C8.42144 12.0783 8.00001 11.0609 8.00001 10C8.00001 8.93913 8.42144 7.92172 9.17158 7.17157C9.92173 6.42143 10.9391 6 12 6ZM12 8C11.4696 8 10.9609 8.21071 10.5858 8.58579C10.2107 8.96086 10 9.46957 10 10C10 10.5304 10.2107 11.0391 10.5858 11.4142C10.9609 11.7893 11.4696 12 12 12C12.5304 12 13.0392 11.7893 13.4142 11.4142C13.7893 11.0391 14 10.5304 14 10C14 9.46957 13.7893 8.96086 13.4142 8.58579C13.0392 8.21071 12.5304 8 12 8Z",
    fill: "white"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4 fw-normal d-none d-lg-inline" }, "MICUENTA", -1))
const _hoisted_12 = {
  class: "offcanvas offcanvas-start bg-dark text-white",
  tabindex: "-1",
  id: "appMenu",
  "aria-labelledby": "appMenuLabel"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "offcanvas-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close btn-close-white custom-close shadow-none border-0",
    "data-bs-dismiss": "offcanvas",
    "aria-label": "Cerrar"
  })
], -1))
const _hoisted_14 = { class: "offcanvas-body p-0" }
const _hoisted_15 = { class: "nav flex-column" }

import { useStore } from 'vuex'
import { key } from '@/setup/store'
import { VuexStore } from '@/interfaces/VuexStore'
// import { useI18n } from 'vue-i18n'
import useLogout from '@/composables/useLogout'
// import { RouterLink } from 'vue-router'
import useImageSever from '@/composables/useImageServer'
import useMenu from '@/composables/useMenu'
import { RouterLink } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'AppSideBarComponent',
  setup(__props) {

const { state, getters } = useStore<VuexStore>(key)
// const { t } = useI18n()
const { logOut } = useLogout()
const { getPathImageServer } = useImageSever()

const { menu } = useMenu()

/*
 <nav
      class="navbar-custom navbar-light sticky-top mb-0"
    >
      <div>
        <div class="superior">
          <a href="/">
            <img class="logo" :src="state.evento.logo" />
          </a>
          <div
            v-if="!state.evento?.fidelizacion"
            class="d-flex justify-content-center"
          >
            <h4 class="nombre-evento-custom m-0 text-uppercase">
              {{ state.evento.nombre }}
            </h4>
          </div>
          <router-link
            class="d-block d-lg-none text-decoration-none fw-bold text-white"
            to="/login"
            v-if="!getters.isLogin"
          >
            INGRESAR
          </router-link>
          <div class="d-block d-lg-none" @click="logOut()" v-else>
            <i class="fas fa-sign-out-alt fa-2x text-white"></i>
          </div>
        </div>
        <ul class="inferior navbar-nav" v-if="!state.evento.fidelizacion">
          <li class="nav-item active">
            <router-link
              class="nav-link fw-bold"
              :to="getters.actualUbicacionURL"
              :class="!getters.isComplete ? '' : 'disabled'"
            >
              <span class="d-none d-lg-inline">1. </span
              >{{ !state.evento.fidelizacion ? t('menu.item1') : 'Categorias' }}
            </router-link>
          </li>
          <li
            class="nav-item"
            :class="
              getters.actualActividadURL.hasOwnProperty('name') ? 'active' : ''
            "
          >
            <router-link
              class="nav-link fw-bold"
              :to="getters.actualActividadURL"
              :class="
                getters.actualActividadURL.hasOwnProperty('name') &&
                !getters.isComplete
                  ? ''
                  : 'disabled'
              "
              ><span class="d-none d-lg-inline">2. </span>{{ t('menu.item2') }}
            </router-link>
          </li>
          <li
            class="nav-item"
            :class="getters.resumenURL.hasOwnProperty('name') ? 'active' : ''"
          >
            <router-link
              class="nav-link fw-bold"
              :to="getters.actualFormularioURL"
              :class="
                getters.actualFormularioURL.hasOwnProperty('name') &&
                !getters.resumenURL.hasOwnProperty('name') &&
                !getters.isComplete
                  ? ''
                  : 'disabled'
              "
              ><span class="d-none d-lg-inline">3. </span>{{ t('menu.item3') }}
            </router-link>
          </li>
          <li
            class="nav-item"
            :class="getters.resumenURL.hasOwnProperty('name') ? 'active' : ''"
          >
            <router-link
              class="nav-link fw-bold"
              :to="getters.resumenURL"
              :class="
                getters.resumenURL.hasOwnProperty('name') && !getters.isComplete
                  ? ''
                  : 'disabled'
              "
              ><span class="d-none d-lg-inline">4. </span>{{ t('menu.item4') }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="mt-5">
        <template v-if="!getters.isLogin">
          <router-link
            class="
              link-login-custom
              nav-link
              text-center
              fw-bold
              text-uppercase
              d-none d-lg-block
            "
            to="/login"
          >
            {{ t('menu.item5') }}
          </router-link>
          <router-link
            class="
              link-login-custom
              nav-link
              text-center
              fw-bold
              text-uppercase
              d-none d-lg-block
            "
            :to="{ name: 'Register' }"
            v-if="state.evento.fidelizacion && !state.evento.porInvitacion"
          >
            Registrarme
          </router-link>
        </template>
        <template v-else>
          <router-link
            v-if="state.evento.fidelizacion"
            :to="{ name: 'MiCuenta' }"
            class="nav-link fw-bold text-uppercase d-none d-lg-block"
            style="cursor: pointer"
          >
            Mi cuenta
          </router-link>
          <div
            class="nav-link fw-bold text-uppercase d-none d-lg-block"
            style="cursor: pointer"
            @click="logOut()"
          >
            {{ t('menu.item6') }}
          </div>
        </template>
      </div>
      <div class="d-flex justify-content-center" v-if="state.evento.emblema">
        <img height="35" :src="state.evento.emblema" class="fallback" alt="" />
      </div>
    </nav>
*/

return (_ctx: any,_cache: any) => {
  return (_unref(state).evento)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(RouterLink), {
              class: "navbar-brand m-0",
              to: { name: 'Home' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(getPathImageServer)(_unref(state).evento.logo),
                  alt: "Logo",
                  height: "50"
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!_unref(getters).isLogin)
              ? (_openBlock(), _createBlock(_unref(RouterLink), {
                  key: 0,
                  to: { name: 'Login' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(RouterLink), {
                    to: { name: 'MiCuenta' },
                    class: "nav-link fw-bold text-uppercase",
                    style: {"cursor":"pointer"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "d-inline ms-4",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(logOut)()))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-sign-out-alt fa-2x", { 'text-white': _unref(state).evento?.theme !== 'citroen_fidelizacion_rebranding' }])
                    }, null, 2)
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("ul", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (hash) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: hash,
                  class: "nav-item border-bottom border-white py-3"
                }, [
                  _createVNode(_unref(RouterLink), {
                    class: "nav-link text-white text-uppercase",
                    to: { name: 'Home', hash: '#' + hash }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(hash), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})